import { Typography } from 'antd';
import styled, { css } from 'styled-components';

const { Paragraph, Title } = Typography;

export const Content = styled.div`
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
`;

export const StyledStatus = styled.div<{ $status: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  gap: 6px;
  border-radius: 2px;
  border: 1px solid;
  max-height: 27px;
  max-width: 72px;
  ${({ $status }) => {
    if ($status === 'high') {
      return css`
        border-color: #ff4c4e;
        color: #ff4c4e;
        background-color: rgba(255, 76, 78, 0.24);

        > div {
          color: #ff4c4e;
        }
      `;
    }

    if ($status === 'norm') {
      return css`
        border-color: #35b678;
        background-color: rgba(101, 223, 165, 0.24);

        > div {
          color: #35b678;
        }
      `;
    }

    if ($status === 'low') {
      return css`
        border-color: #ff7f4e;
        color: #ff7f4e;
        background-color: rgba(255, 127, 78, 0.24);

        > div {
          color: #ff7f4e;
        }
      `;
    }
  }}

  > div {
    margin: 0;
  }
`;

export const Table = styled.table`
  border-radius: 6px 6px 0 0;
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #f5f6f8;
  display: grid;
  grid-template-columns: repeat(3, 1fr) 100px 50px;
  gap: 10px;
  align-items: center;
`;

export const TableHeader = styled.th`
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: 700;
  height: 56px;
  color: #18212c;
  font-size: 16px;
`;

export const TableData = styled.td`
  display: flex;
  align-items: center;
  min-height: 56px;
  padding-block: 12px;
  text-align: left;
  font-size: 16px;
  color: #18212c;

  > * {
    font-size: 16px;
  }
`;

export const ResultBody = styled.div`
  background-color: #f5f6f8;
  padding: 20px;
  border-radius: 12px;
  margin-top: 24px;
`;

export const StyledDate = styled(Paragraph)`
  &&& {
    margin: 0;
    font-size: 16px;
    color: #63687a;
  }
`;

export const TestTitle = styled(Title)`
  &&& {
    font-size: 18px;
    margin: 0;
    font-weight: 600;
    color: #18212c;
  }
`;
